import { Form, FormState } from 'informed';
import { useState } from 'react';
import { useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';

import feathersClient from '../../../../../apiClient';
import { ErrorAlert, SuccessAlert } from '../../../../../components/alerts';
import { SubmitButton } from '../../../../../components/buttons';
import Wrapper from '../../../../../components/wrapper';
import Container from '../../../../../containers';
import { BranchofficeData } from '../../../../../types/TymbeApi';
import Spinner from '../../../../../utils/spinner';
import DepartmentForm from '../components/DepartmentForm';
import mapFormValuesToDepartment from '../Department.utils';

const CreateDepartment = () => {
  const { companyId } = useParams();
  const history = useNavigate();
  const [formDisabled, setFormDisabled] = useState(false);

  const { data: company, isLoading } = useQuery(
    ['FetchCompany', companyId],
    async () => feathersClient.service('company').get(
      Number(companyId),
    ),
    { enabled: !!companyId },
  );
  const onSubmit = async ({ values }: FormState<BranchofficeData>) => {
    setFormDisabled(true);

    const data = mapFormValuesToDepartment(values, Number(companyId));

    try {
      await feathersClient.service('branchoffice').create(data);
      SuccessAlert('Oddělení vytvořeno');
      history(`/company/${companyId}/department`);
    } catch {
      ErrorAlert('Nastala chyba');
    }

    setFormDisabled(false);
  };

  return (
    <Container
      iconcolor="#B3CA1F"
      background="#fff"
      elevate
      contentstyle={{ paddingLeft: '170px' }}
      desktopHeader
      sidebar
    >
      {isLoading ? (<Spinner />) : (
        <Wrapper padding="0px" margin="0px 22px 18px 31px">
          <h1>Nové oddělení</h1>
          <Form name="create_department_form" onSubmit={onSubmit}>
            <DepartmentForm company={company} />
            <SubmitButton disabled={formDisabled} style={{ marginTop: '18px' }} buttontext="Uložit" />
          </Form>
        </Wrapper>
      )}
    </Container>
  );
};

export default CreateDepartment;
